/* esm.sh - js-yaml@4.1.0 */
export * from "/v135/js-yaml@4.1.0/denonext/js-yaml.mjs";
export { default } from "/v135/js-yaml@4.1.0/denonext/js-yaml.mjs";
